import { DeviceAdapter } from "@validereinc/domain";
import { useEffect, useState } from "react";

export const useDeviceDetail = (
  id: string,
  dependencies: any[] = []
): [any, boolean] => {
  const [isLoading, setIsLoading] = useState(true);
  const [deviceDetail, setDeviceDetail] = useState({});

  useEffect(() => {
    (async () => {
      if (id) {
        setIsLoading(true);
        const response = await DeviceAdapter.getOne({ id });
        setDeviceDetail(response.data);
        setIsLoading(false);
      }
    })();
  }, [id, ...dependencies]);

  return [deviceDetail, isLoading];
};
